export default {
  "bg-gradient":
    "--m-gd-dir: to bottom;--m-gd-start-color: ;--m-gd-mid-color: ;--m-gd-end-color: ;background-image: linear-gradient(var(--m-gd-dir), var(--m-gd-start-color), var(--m-gd-mid-color) var(--m-gd-end-color))",
  "filter-none": "filter: none;-webkit-filter: none",
  "backdrop-filter-none": "backdrop-filter: none;-webkit-backdrop-filter: none",
  "transform-none":
    "transform: none;-webkit-transform: none;-ms-transform: none",
  "transition-none":
    "-mojo-d-transition-property: none;-webkit--mojo-d-transition-property: none;-o--mojo-d-transition-property: none",
  grid: "display: grid;grid-template-columns: repeat(1, minmax(0, 1fr));grid-gap: 1rem;--m-box-start: start;--m-box-end: end",
  "cols-auto": "grid-template-columns: repeat(auto-fit, minmax(0, 1fr))",
  "rows-auto": "grid-template-rows: repeat(auto-fit, minmax(0, 1fr))",
  "col-auto": "grid-column: auto",
  "col-offset-auto": "grid-column-start: auto",
  "flex-fluid": "flex: 1 1 0%",
  "flex-auto": "flex: 1 1 auto",
  "flex-none": "flex: none",
  "flex-wrap": "flex-wrap: wrap",
  "flex-nowrap": "flex-wrap: nowrap",
  "flex-wrap-reverse": "flex-wrap: wrap-reverse",
  "flex-col": "flex-direction: column",
  "flex-row": "flex-direction: row",
  "flex-col-reverse": "flex-direction: column-reverse",
  "flex-row-reverse": "flex-direction: row-reverse",
  "text-wb-normal": "word-break: normal;overflow-wrap: normal",
  "text-wb-words": "overflow-wrap: break-word",
  "text-wb-all": "word-break: break-all",
  "text-wb-keep": "word-break: keep-all",
  "text-truncate":
    "overflow: hidden;text-overflow: ellipsis;white-space: nowrap",
  hidden: "visibility: hidden",
  visible: "visibility: visible",
  "resize-xy": "resize: both",
  "resize-x": "resize: horizontal",
  "resize-y": "resize: vertical",
  "outline-none": "outline:none",
};
